<template>
  <section class="page cart">
    <cart-table :goodsList="getShoppingCart" type="cart"></cart-table>
    <section class="ou-card-box like-list">
      <el-tabs v-model="activeTab" @tab-click="switchTab">
        <el-tab-pane label="热卖推荐" name="hot">
          <card-row :list="hotList"></card-row>
        </el-tab-pane>
        <el-tab-pane label="猜你喜欢" name="like">
          <card-row :list="likeList"></card-row>
        </el-tab-pane>
      </el-tabs>
    </section>
    <div class="ou-card-bottom-gap"></div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { getGuessFavouriteForLogin, goodBookList } from "@/api/index/index";
import { apiGetCartList } from "@/api/cart/cart";
import CartTable from "./components/CartTable";
import CardRow from "./components/CardRow";
export default {
  name: "cart",
  components: { CartTable, CardRow },
  data() {
    return {
      activeTab: "hot",
      hotList: [],
      likeList: [],
    };
  },
  watch: {},
  computed: {
    ...mapGetters(["getShoppingCart", "userId"]),
  },
  mounted() {
    console.log("this.getShoppingCart", this.getShoppingCart);
    apiGetCartList().then((res) => {
      let { rows = [] } = res;
      let data = [];
      rows.map((item) => {
        data.push({ ...item, isCheck: false });
      });
      this.$store.dispatch("setShoppingCart", data);
    }),
      this.getHotRecommended();
  },
  methods: {
    switchTab(e, v) {
      e.name === "hot" && this.getHotRecommended();
      e.name === "like" && this.getUserLike();
    },
    getHotRecommended() {
      goodBookList({ pageNum: 1, pageSize: 6 })
        .then((res) => {
          let data = res.data || [],
            list = [];
          data.forEach((item, index) => {
            if (index <= 5) {
              let {
                bookName: goodsTitle,
                sourceFile,
                cover,
                bookId: goodsId,
                goodsType: goodsType,
              } = item;
              list.push({ goodsTitle, cover, sourceFile, goodsId, goodsType });
            }
          });
          this.hotList = list;
        })
        .catch((err) => (this.hotList = []));
    },
    getUserLike() {
      getGuessFavouriteForLogin()
        .then((res) => {
          let list = res.data || [];
          this.likeList = list;
        })
        .catch((err) => (this.likeList = []));
    },
  },
};
</script>

<style scoped lang="scss">
.like-list ::v-deep {
  box-sizing: border-box;
  padding: 0 16px;
  // margin-bottom: 32px;
  .el-tabs__nav-wrap::after {
    background-color: #ffffff;
  }
  .el-tabs__item.is-active {
    color: #2e9adb;
  }
  .el-tabs__active-bar {
    background-color: #2e9adb;
  }
}
</style>
